module.exports = __webpack_public_path__ + "img/img-aae8ea95.dfdf6399.png";